// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e5VJ","largestCol":"styles_largestCol__3umAG","smallestCol":"styles_smallestCol__2yrXA"};